import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { GET_PROPERTIES_PATH } from 'src/services/api/properties/constants';

type ISetPropertyContactsEnabledRequest = {
    propertyId: number;
    enabled: boolean;
};

export const useSetPropertyContactsEnabled = () => {
    const queryClient = useQueryClient();

    return useMutation<void, IStandardErrorResponse, ISetPropertyContactsEnabledRequest>(
        async ({ propertyId, enabled }) => {
            await apiClient(`${GET_PROPERTIES_PATH}/${propertyId}`, {
                method: 'patch',
                json: { property: { is_contacts_invited: enabled } },
            });
        }, {
            onSuccess: async () => {
                await Promise.all([
                    queryClient.invalidateQueries(queryKeys.contacts),
                    queryClient.invalidateQueries(queryKeys.properties),
                ]);
            },
        }
    );
};
